export class GenericIDs {
    public Ids: number[];
}

export class GenericID {
    public ID: number;
}

export class GenericValueObject {
    public value: string;
}